import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuestionTypePipe } from './question-type.pipe';
import { QuestionTypeTranslationComponent } from './question-type-translation.component';

import { TranslationModule } from '@schoolbelle/common/translation';

@NgModule({
  imports: [
    CommonModule, 
    TranslationModule.forRoot(),
  ],
  declarations: [QuestionTypePipe, QuestionTypeTranslationComponent],
  exports: [QuestionTypePipe, QuestionTypeTranslationComponent],
 entryComponents: [QuestionTypeTranslationComponent],
})
export class QuestionTypeModule {}
